import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import './MaintenanceItem.scss'
import { ViewerItem, MOVE_NONE } from '@teqplay/viewer'

export default class MaintenanceItem extends PureComponent {
  static propTypes = {
    terminalMaintenance: PropTypes.object.isRequired,
    onSelectMaintenanceItem: PropTypes.func.isRequired,
    selectedMaintenance: PropTypes.object,
    timeToScreen: PropTypes.func.isRequired,
    bollardToScreen: PropTypes.func.isRequired
  }

  render() {
    const MaintenceItemDetails = this.convertMaintenceItem()

    const isSelectedItem =
      this.props.selectedMaintenance && this.props.terminalMaintenance._id === this.props.selectedMaintenance._id

    const startTime = this.props.terminalMaintenance.startTime
    const endTime = this.props.terminalMaintenance.endTime

    const maintenanceIsCompleted = endTime <= moment().valueOf()
    const maintenanceIsTakingPlace = startTime <= moment().valueOf() && endTime > moment().valueOf()

    // CSS classes for the maintenance item
    const maintenanceItemCssClasses = `maintenance-item
                                    ${isSelectedItem ? 'selected' : ''}
                                    ${maintenanceIsCompleted ? 'completed' : ''}
                                    ${maintenanceIsTakingPlace ? 'active' : ''}`

    return (
      <ViewerItem
        item={MaintenceItemDetails}
        movement={MOVE_NONE}
        yUnitToScreen={this.props.timeToScreen}
        xUnitToScreen={this.props.bollardToScreen}
        className={maintenanceItemCssClasses}
      >
        <div
          className={maintenanceItemCssClasses}
          onClick={() => this.props.onSelectMaintenanceItem(this.props.terminalMaintenance)}
        >
          <div className="maintenance-item-content">
            <div className="bollard-indicator-wrapper">
              {`${this.props.terminalMaintenance.bollardStart} | ${this.props.terminalMaintenance.bollardEnd}`}
            </div>
            <div className="maintenance-item-range-contents">{this.props.terminalMaintenance.message}</div>
          </div>
        </div>
      </ViewerItem>
    )
  }

  convertMaintenceItem = () => {
    const startTime = this.props.terminalMaintenance.startTime
    const endTime = this.props.terminalMaintenance.endTime

    return {
      _id: this.props.terminalMaintenance._id,
      xStart: this.props.terminalMaintenance.bollardStart,
      xEnd: this.props.terminalMaintenance.bollardEnd,
      yStart: new Date(startTime),
      yEnd: new Date(endTime),
      referenceTerminalVisit: this.props.terminalMaintenance
    }
  }
}
